module.exports = __webpack_public_path__ + "static/img/アセット 4@2x.54bd55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 4@2x.png
// module id = C5wH
// module chunks = 1